function support_format_webp() {
  
  const allBg = document.querySelectorAll(".has-bg");
  var elem = document.createElement("canvas");

  if (!!(elem.getContext && elem.getContext("2d"))) {
    // was able or not to get WebP representation

  } else {
    // very old browser like IE 8, canvas not supported
    if (allBg) {
      allBg.forEach((bg) => {
        bg.classList.add("no-webp");
      });
    }
  }
}
support_format_webp();


